import {
  Box,
  Button,
  Container,
  Grid,
  Snackbar,
  Alert,
  Typography,
} from "@mui/material";
import {
  FaceHappy,
  FaceNeutral,
  FaceNeutralHappy,
  FaceNeutralSad,
  FaceNull,
  FaceSad,
} from "assets/icons/config";
import { useAuthToken } from "hooks/useAuthToken";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ratingTicket } from "services/ticket";

export default function RatingTicket() {
  const [searchParams] = useSearchParams();
  const uuid = searchParams.get("uuid");

  const { getAuthToken } = useAuthToken();
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "",
  }); // Estado para el alert

  const ratingTicketSubmit = async (uuid, ticketRating) => {
    setLoading(true);
    setAlert({ open: false, message: "", severity: "" });
    try {
      await getAuthToken();
      await ratingTicket(uuid, ticketRating);
      setAlert({
        open: true,
        message: "Gracias por tu respuesta.",
        severity: "success",
      });
    } catch (err) {
      setAlert({
        open: true,
        message: `Ocurrió un error: ${
          err.message || "Intenta de nuevo más tarde."
        }`,
        severity: "error",
      });
    } finally {
      setTimeout(() => {
        setLoading(false);
        window.location.replace("https://bodytech.com.co");
      }, 2000);
    }
  };

  return (
    <div>
      <Container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "1000px",
            width: "100%",
          }}
        >
          <Typography variant="h4" sx={{ marginBottom: 3 }}>
            ¿Cómo calificarías tu experiencia?
          </Typography>
          <Grid container spacing={4} justifyContent="center">
            {[1, 2, 3, 4, 5].map((rating, index) => {
              const icons = [
                FaceSad,
                FaceNeutralSad,
                FaceNeutral,
                FaceNeutralHappy,
                FaceHappy,
              ];
              const descriptions = [
                "Muy insatisfecho",
                "Insatisfecho",
                "Neutral",
                "Satisfecho",
                "Muy Satisfecho",
              ];
              const IconComponent = icons[index];
              return (
                <Grid
                  key={rating}
                  item
                  xs={2}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                >
                  {!loading ? (
                    <Button
                      onClick={() => ratingTicketSubmit(uuid, rating)}
                      sx={{
                        marginBottom: "30px",
                        height: "100px",
                        boxShadow: "none",
                        transition: "box-shadow 0.3s ease",
                        "&:hover": {
                          boxShadow: "none",
                          backgroundColor: "transparent",
                        },
                        "&:active": {
                          boxShadow: "none",
                          backgroundColor: "transparent",
                        },
                      }}
                    >
                      <IconComponent />
                    </Button>
                  ) : (
                    <FaceNull />
                  )}
                  <Typography variant="body2">{descriptions[index]}</Typography>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Container>

      {/* Snackbar para alertas */}
      <Snackbar
        open={alert.open}
        autoHideDuration={6000}
        onClose={() => setAlert({ ...alert, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setAlert({ ...alert, open: false })}
          severity={alert.severity}
          sx={{ width: "100%" }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
